import React from "react";
import { Copy, Download, Printer, Save, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import LabelPreview from "@/components/LabelPreview";
import { getDDMM } from "@/lib/codegen";

export const GeneratorPreviewActions = ({
  form,
  generatedCode,
  saving,
  lastSaved,
  totalForPreview,
  onCopy,
  onShare,
  onPrint,
  onDownload,
  onSave,
  onReset,
}) => (
  <aside className="lg:col-span-5 flex flex-col gap-4 lg:sticky lg:top-24 self-start">
    <LabelPreview
      shipment={{ ...form, generated_code: generatedCode, created_at: new Date().toISOString() }}
      pageIndex={1}
    />

    {form.package_mode === "auto" && totalForPreview > 1 && (
      <div className="text-[11px] uppercase tracking-[0.16em] text-zinc-500 text-center font-mono">
        Showing 1 of {totalForPreview} pages — PDF will include all
      </div>
    )}

    <Card className="border-zinc-200 shadow-sm">
      <div className="p-4 grid grid-cols-2 gap-2">
        <Button onClick={onCopy} data-testid="btn-copy" className="h-11 bg-zinc-900 hover:bg-zinc-800 text-white">
          <Copy className="w-4 h-4 mr-1.5" /> Copy
        </Button>
        <Button onClick={onShare} data-testid="btn-share" variant="outline" className="h-11 border-zinc-300 hover:bg-zinc-50">
          <Share2 className="w-4 h-4 mr-1.5" /> Share
        </Button>
        <Button onClick={onPrint} data-testid="btn-print" variant="outline" className="h-11 border-zinc-300 hover:bg-zinc-50">
          <Printer className="w-4 h-4 mr-1.5" /> Print
        </Button>
        <Button onClick={onDownload} data-testid="btn-download-pdf" variant="outline" className="h-11 border-zinc-300 hover:bg-zinc-50">
          <Download className="w-4 h-4 mr-1.5" /> PDF
        </Button>
        <Button onClick={onSave} disabled={saving} data-testid="btn-save" className="col-span-2 h-11 bg-blue-700 hover:bg-blue-800 text-white">
          <Save className="w-4 h-4 mr-1.5" /> {saving ? "Saving…" : "Save Shipment"}
        </Button>
      </div>
    </Card>

    <div className="flex items-center justify-between">
      <Button onClick={onReset} variant="ghost" data-testid="btn-reset" className="text-xs uppercase tracking-[0.16em] text-zinc-500 hover:text-zinc-900">
        Reset Form
      </Button>
      {lastSaved && (
        <a href="/shipments" className="text-xs uppercase tracking-[0.16em] text-blue-700 hover:underline">
          View in Shipments →
        </a>
      )}
    </div>

    <Separator />
    <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-400 text-center font-mono">
      Format · DA/DS — T? — B? — W? — BB? — M? — RF — SHORTCODE{`{seq}`} — {getDDMM()}
    </div>
  </aside>
);
